import React from "react";
import { useSelector } from "react-redux";
import { Close } from "@mui/icons-material";

import { Icon } from "components";
import { getHeaderBgColor, getIsMaximized, getIsMobileWindow, selectIsPhotoTourScreen, selectIsVideoTourScreen, unitSliceData } from "slices";

const AlertModal = ({ children, icon, onClose, className = "" }) => {
  const isMaximized = useSelector(getIsMaximized);
  const isVideoTourScreen = useSelector(selectIsVideoTourScreen);
  const isPhotoTourScreen = useSelector(selectIsPhotoTourScreen);
  const { isUnitTourScreen } = useSelector(unitSliceData);
  const isMobile = useSelector(getIsMobileWindow);
  const backgroundColor = useSelector(getHeaderBgColor);

  return (
    <div
      className={`hayley-z-50 hayley-flex hayley-w-full hayley-items-center hayley-justify-between hayley-bg-white hayley-px-4 hayley-py-3 hayley-text-sm hayley-shadow-2xl ${
        (isMaximized || isVideoTourScreen || isPhotoTourScreen || isUnitTourScreen) && !isMobile
          ? "hayley-absolute hayley-inset-x-0 hayley-top-10 hayley-mx-auto !hayley-w-[500px] hayley-py-4 hayley-text-base"
          : ""
      } ${className}`}
    >
      <div className="hayley-flex hayley-items-center hayley-space-x-3">
        {icon && <Icon iconType={icon} />}

        {children}
      </div>
      <Close className="hayley-h-6 hayley-w-6 hayley-cursor-pointer" sx={{ "&:hover": { color: `${backgroundColor} !important` } }} onClick={onClose} />
    </div>
  );
};

export default AlertModal;
